(function () {
  if (window.scSpinReady) return;
  window.scSpinReady = true;

  // Plain: a photo-real studio turntable over the 3D
  // slide, from Blender frames (spin/render.py).
  // Room: the live 3D model in its lit room (sc-pdp.js).
  var KEY = 'scpScenePlain';
  var SPEED = 14; // auto turn, degrees a second
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lite() {
    var c = navigator.connection || {};
    return !!(c.saveData || /2g|3g/.test(c.effectiveType || '') || (navigator.deviceMemory && navigator.deviceMemory <= 2));
  }

  function plain() {
    try {
      return window.localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function norm(s) {
    return String(s || '').trim().toLowerCase();
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html) e.innerHTML = html;
    return e;
  }

  function pad(i) {
    return i < 10 ? '0' + i : '' + i;
  }

  function attach(info, m, base, stem) {
    var pm = info.querySelector('media-gallery product-model');
    var box = pm && pm.closest('.product-media-container');
    if (!box || box.querySelector('.scp-spin')) return;
    var S = m.size;
    if (!m.bd.p) return;
    var bd = 'p';
    var fin = 0;
    var want = 0;
    var ang = 0;
    var vel = 0;
    var auto = !calm && !lite();
    var on = false;
    var seen = false;
    var touched = false;
    var frames = {};
    var layers = {};
    var width = 1000;

    var wrap = el('div', 'scp-spin');
    var cv = el('canvas', 'scp-spin__cv');
    var hint = el('span', 'scp-spin__hint', 'Drag to turn');
    var ctx = cv.getContext('2d');
    wrap.appendChild(cv);
    wrap.appendChild(hint);
    wrap.setAttribute('aria-label', 'Turn the light fitting: drag, or use the arrow keys');
    wrap.setAttribute('role', 'img');
    wrap.tabIndex = 0;
    box.appendChild(wrap);

    // backdrop and 3D buttons; sc-pdp.js presses the
    // backdrop buttons and saves the choice
    var bar = box.querySelector('.scp-scene');
    if (!bar) {
      bar = el('div', 'scp-scene');
      bar.setAttribute('role', 'group');
      bar.setAttribute('aria-label', 'View');
      bar.innerHTML =
        '<button type="button" data-scp-scene="room">Room</button><button type="button" data-scp-scene="plain">Plain</button>';
      box.appendChild(bar);
    }
    function pressBar() {
      var p = plain();
      bar.querySelectorAll('[data-scp-scene]').forEach(function (b) {
        b.setAttribute('aria-pressed', (b.dataset.scpScene === 'plain') === p);
      });
    }
    pressBar();

    function N(t) {
      return m.bd[t || bd].n;
    }

    // wall lights swing across the front (a0 .. a0 + period);
    // everything else turns, repeating every period
    var swing = m.bd[bd].mode === 'swing';
    var dir = 1;

    function idx(t) {
      var e = m.bd[t || bd];
      if (e.mode === 'swing') {
        var j = Math.round((ang - e.a0) / (e.period / (e.n - 1)));
        return Math.max(0, Math.min(e.n - 1, j));
      }
      var i = Math.round(ang / (e.period / e.n)) % e.n;
      return i < 0 ? i + e.n : i;
    }

    function clampAng() {
      if (!swing) return;
      var e = m.bd[bd];
      ang = Math.max(e.a0, Math.min(e.a0 + e.period, ang));
    }

    function url(name, w) {
      return base + name + '?width=' + w;
    }

    function load(list, done) {
      var i = 0;
      var busy = 0;
      if (!list.length && done) return done();
      function next() {
        while (busy < 4 && i < list.length) {
          var job = list[i++];
          if (job.store[job.k]) {
            if (i >= list.length && !busy && done) done();
            continue;
          }
          busy++;
          var img = new Image();
          img.decoding = 'async';
          img.onload = img.onerror = (function (job, img) {
            return function (e) {
              busy--;
              if (e.type === 'load') {
                job.store[job.k] = img;
                draw();
              }
              if (i >= list.length && !busy && done) done();
              next();
            };
          })(job, img);
          img.src = job.src;
        }
      }
      next();
    }

    function order(t) {
      var n = N(t);
      var c = idx(t);
      var out = [c];
      for (var d = 1; out.length < n; d++) {
        out.push((c + d) % n);
        if (out.length < n) out.push((c - d + n) % n);
      }
      return out;
    }

    function baseJobs(t, all) {
      frames[t] = frames[t] || {};
      return (all ? order(t) : [idx(t)]).map(function (i) {
        return { store: frames[t], k: i, src: url(stem + '-' + t + '-b' + pad(i) + '.webp', width) };
      });
    }

    function layerJobs(t, f, all) {
      var key = t + f;
      var rects = m.bd[t].layers[f] || [];
      layers[key] = layers[key] || {};
      return (all ? order(t) : [idx(t)])
        .filter(function (i) {
          return rects[i];
        })
        .map(function (i) {
          var w = Math.max(16, Math.round((rects[i][2] * width) / S));
          return { store: layers[key], k: i, src: url(stem + '-' + t + '-f' + f + '-' + pad(i) + '.webp', w) };
        });
    }

    function nearest(store, i, n) {
      if (store[i]) return i;
      for (var d = 1; d < n; d++) {
        if (store[(i + d) % n]) return (i + d) % n;
        if (store[(i - d + n) % n]) return (i - d + n) % n;
      }
      return -1;
    }

    function size() {
      var r = box.getBoundingClientRect();
      if (r.width < 120) return; // not laid out yet
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.round(r.width * dpr);
      var h = Math.round(r.height * dpr);
      if (w && (cv.width !== w || cv.height !== h)) {
        cv.width = w;
        cv.height = h;
      }
      width = Math.min(S, Math.ceil(Math.max(w, h) / 100) * 100);
      draw();
    }

    // one frame: base image plus the chosen finish's layer
    function paint(img, rect, L, alpha) {
      var s = Math.max(cv.width / S, cv.height / S);
      var ox = (cv.width - S * s) / 2;
      var oy = (cv.height - S * s) / 2;
      ctx.globalAlpha = alpha;
      ctx.drawImage(img, ox, oy, S * s, S * s);
      if (rect && L) ctx.drawImage(L, ox + rect[0] * s, oy + rect[1] * s, rect[2] * s, rect[3] * s);
      ctx.globalAlpha = 1;
    }

    function ready(i) {
      var e = m.bd[bd];
      var store = frames[bd] || {};
      if (!store[i]) return false;
      return !want || !e.layers[want][i] || !!(layers[bd + want] || {})[i];
    }

    function draw() {
      if (!cv.width) return;
      var store = frames[bd] || {};
      var e = m.bd[bd];
      var i = idx();
      if (!ready(i)) {
        for (var d = 1; d < e.n; d++) {
          if (ready((i + d) % e.n)) { i = (i + d) % e.n; break; }
          if (ready((i - d + e.n) % e.n)) { i = (i - d + e.n) % e.n; break; }
        }
        if (!ready(i)) i = nearest(store, idx(), e.n);
      }
      // a new finish shows once its layer for this angle is in
      if (want !== fin && (!want || (layers[bd + want] || {})[i] || !e.layers[want][i])) fin = want;
      if (i < 0) return;
      paint(store[i], fin && e.layers[fin][i], fin && (layers[bd + fin] || {})[i], 1);
      if (!wrap.classList.contains('is-ready')) wrap.classList.add('is-ready');
    }

    function loadAll() {
      var list = baseJobs(bd, true);
      if (want) {
        var lay = {};
        layerJobs(bd, want, true).forEach(function (j) {
          lay[j.k] = j;
        });
        list = list.reduce(function (acc, j) {
          acc.push(j);
          if (lay[j.k]) acc.push(lay[j.k]);
          return acc;
        }, []);
      }
      load(list);
    }

    // turning: auto spin until touched, then drag with a
    // little momentum
    var raf = 0;
    var last = 0;
    function spinning() {
      return auto && seen && !touched && on;
    }
    function run() {
      if (raf) return;
      last = performance.now();
      raf = requestAnimationFrame(tick);
    }
    function tick(now) {
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      var before = idx();
      if (!drag && Math.abs(vel) > 2) {
        ang += vel * dt;
        vel *= Math.exp(-dt * 3.5);
        clampAng();
      } else if (!drag && spinning()) {
        ang += dir * SPEED * dt;
        if (swing) {
          var e = m.bd[bd];
          if (ang >= e.a0 + e.period) dir = -1;
          if (ang <= e.a0) dir = 1;
          clampAng();
        }
      } else if (!drag) vel = 0;
      if (idx() !== before || want !== fin) draw();
      raf = drag || Math.abs(vel) > 2 || spinning() ? requestAnimationFrame(tick) : 0;
    }

    var drag = null;
    function down(e) {
      if (!on || e.button > 0) return;
      if (e.pointerType === 'touch' && !wrap.classList.contains('is-live')) return;
      drag = { x: e.clientX, t: performance.now(), v: 0 };
      wrap.setPointerCapture(e.pointerId);
      stopAuto();
      vel = 0;
      run();
    }
    function move(e) {
      if (!drag) return;
      var r = box.getBoundingClientRect();
      var d = ((e.clientX - drag.x) / Math.max(r.width, 1)) * 300;
      var now = performance.now();
      var dt = Math.max(1, now - drag.t) / 1000;
      drag.v = 0.7 * drag.v + 0.3 * (d / dt);
      drag.x = e.clientX;
      drag.t = now;
      var before = idx();
      ang += d;
      clampAng();
      if (idx() !== before) draw();
    }
    function up() {
      if (!drag) return;
      vel = performance.now() - drag.t < 80 ? Math.max(-400, Math.min(400, drag.v)) : 0;
      drag = null;
      run();
    }
    function stopAuto() {
      if (!touched) {
        touched = true;
        hint.classList.add('is-gone');
        if (Object.keys(frames[bd] || {}).length < N()) loadAll();
      }
    }

    wrap.addEventListener('pointerdown', down);
    wrap.addEventListener('pointermove', move);
    wrap.addEventListener('pointerup', up);
    wrap.addEventListener('pointercancel', up);
    // phones: a tap starts turning, so swipes still move
    // the gallery until then
    wrap.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!wrap.classList.contains('is-live')) {
        wrap.classList.add('is-live');
        hint.textContent = 'Drag to turn';
        stopAuto();
      }
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      stopAuto();
      ang += (e.key === 'ArrowLeft' ? -1 : 1) * Math.max(m.bd[bd].period / m.bd[bd].n, 5);
      clampAng();
      draw();
    });
    if (window.matchMedia('(hover: none)').matches) hint.textContent = 'Tap to turn';
    else wrap.classList.add('is-live');

    function show(photo) {
      on = photo;
      wrap.hidden = !photo;
      if (photo) {
        size();
        load(baseJobs(bd, false).concat(want ? layerJobs(bd, want, false) : []), function () {
          draw();
          if (seen && !lite()) loadAll();
        });
        run();
        return;
      }
      if (seen) live();
    }

    // Room: load the live model (Dawn defers it until its
    // poster is clicked); sc-pdp.js mounts it in the room
    function live() {
      var poster = pm.querySelector('.deferred-media__poster');
      if (poster && !pm.querySelector('model-viewer')) poster.click();
    }

    // backdrop buttons: sc-pdp.js saves the choice
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-scp-scene]');
      if (!b) return;
      setTimeout(function () {
        pressBar();
        show(plain());
      }, 0);
    });

    // finish swatches (phones; CSS hides them on wider
    // screens); sc-pdp.js picks the variant on click
    function pickerFor(name) {
      var radios = info.querySelectorAll('variant-selects input[type="radio"]');
      for (var i = 0; i < radios.length; i++) if (norm(radios[i].value) === norm(name)) return radios[i];
      var opts = info.querySelectorAll('variant-selects select option');
      for (var j = 0; j < opts.length; j++) if (norm(opts[j].value) === norm(name)) return opts[j];
      return null;
    }

    function current() {
      var s = info.querySelector('[data-selected-variant]');
      try {
        return s ? JSON.parse(s.textContent) : null;
      } catch (e) {
        return null;
      }
    }

    function finishBar() {
      var names = (m.finishes || []).filter(pickerFor);
      if (names.length < 2 || box.querySelector('.scp-finish')) return;
      var fb = el('div', 'scp-finish');
      fb.setAttribute('role', 'group');
      fb.setAttribute('aria-label', 'Finish');
      var v = current();
      var have = v ? [v.title, v.option1, v.option2, v.option3].filter(Boolean).map(norm) : [];
      names.forEach(function (name) {
        var p = pickerFor(name);
        var sw = p.labels && p.labels[0] && p.labels[0].querySelector('.swatch');
        var b = el('button', 'scp-finish__sw');
        b.type = 'button';
        b.dataset.scpFinish = p.value;
        b.title = p.value;
        b.setAttribute('aria-label', p.value);
        b.setAttribute('aria-pressed', have.indexOf(norm(p.value)) > -1);
        if (sw && sw.getAttribute('style')) b.setAttribute('style', sw.getAttribute('style'));
        fb.appendChild(b);
      });
      box.appendChild(fb);
    }

    function setFinish(v) {
      if (!v || !m.finishes) return;
      var have = [v.title, v.option1, v.option2, v.option3].filter(Boolean).map(norm);
      for (var k = 0; k < m.finishes.length; k++) {
        if (have.indexOf(norm(m.finishes[k])) > -1) {
          if (k === want) return;
          want = k;
          if (!k) return draw();
          load(layerJobs(bd, k, false), function () {
            draw();
            if (seen || touched) load(layerJobs(bd, k, true));
          });
          return;
        }
      }
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        setFinish(event.data && event.data.variant);
      });
    }

    // start when the slide is (nearly) on screen
    function start() {
      if (seen) return;
      seen = true;
      if (!on) return live();
      if (!lite()) loadAll();
      run();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (list) {
          var r = list[0].intersectionRatio;
          if (r >= 0.5) start();
          if (r < 0.1) wrap.classList.remove('is-live');
        },
        { threshold: [0, 0.1, 0.5] }
      ).observe(box);
    } else start();
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(box);
    window.addEventListener('resize', size);

    setFinish(current());
    finishBar();
    size();
    show(plain());
  }

  function boot() {
    var cfg = document.querySelector('[data-scp-spin]');
    var info = document.querySelector('product-info');
    if (!cfg || !info || !window.fetch) return;
    var src = cfg.dataset.scpSpin;
    var path = src.split('?')[0];
    var base = path.replace(/[^/]+$/, '');
    var stem = path.match(/([^/]+)\.json$/)[1];
    fetch(src)
      .then(function (r) {
        return r.json();
      })
      .then(function (m) {
        attach(info, m, base, stem);
      })
      .catch(function () {});
  }

  function later() {
    var go = function () {
      (window.requestIdleCallback || setTimeout)(boot, { timeout: 2500 });
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go);
  }

  later();
})();
